import clsx from 'clsx'

import { anim, pv, stagger } from '../../../motion'
import { DIMS, SCORE, fitOf } from '../../demo/copy'
import { useCopy } from '../../i18n'
import { Odometer } from '../../showcase/stage/fx'
import { C, Shape } from '../shapes'

// Der Wert der Person als Aivy-Form, je Dimension eine andere
const MARKERS = [
  ['circle', C.pink],
  ['tri', C.yellow],
  ['square', C.green],
  ['half', C.blue]
]

/**
 * Ergebnisreport als flache Grafik: Zielbereich und Toleranz je Dimension,
 * die Talentwerte gleiten als Formen an ihren Platz. Rechts der Gesamtscore.
 */
export default function PlTalents() {
  const c = useCopy('talentwerte')
  const ui = useCopy('ui')

  return (
    <div className='ap-talents'>
      <div className='ap-talents__head'>
        <div className='ap-eyebrow'>{c.eyebrow}</div>
        <h2 className='ap-h1'>{c.title}</h2>
        <p className='ap-lead'>{c.sub}</p>
      </div>

      <div
        className='ap-talents__report'
        style={anim({ at: [0, 0.08], y: 40 })}
      >
        <div className='ap-talents__legend'>
          <span>
            <i className='ap-talents__key ap-talents__key--target' />
            {c.target}
          </span>
          <span>
            <i className='ap-talents__key ap-talents__key--tol' />
            {c.tolerance}
          </span>
          <span>
            <Shape kind='circle' color={C.ink} size={10} />
            {c.person}
          </span>
          <span className='ap-talents__sample'>{ui.sample}</span>
        </div>
        {DIMS.map((d, i) => {
          const fit = fitOf(d)
          const [kind, color] = MARKERS[i]
          return (
            <div
              key={d.key}
              className={clsx('ap-talents__row', `is-${fit}`)}
              style={pv('p', stagger(0.16, 0.06, 0.2, i))}
            >
              <span className='ap-talents__label'>
                {c.dims[i]}
                {d.must && <em className='ap-talents__must'>{c.must}</em>}
              </span>
              <span className='ap-talents__track'>
                <i
                  className='ap-talents__band ap-talents__band--tol'
                  style={{
                    left: `${d.trans[0]}%`,
                    width: `${d.trans[1] - d.trans[0]}%`
                  }}
                />
                <i
                  className='ap-talents__band ap-talents__band--target'
                  style={{
                    left: `${d.ideal[0]}%`,
                    width: `${d.ideal[1] - d.ideal[0]}%`
                  }}
                />
                <span
                  className='ap-talents__marker'
                  style={{ '--v': d.person }}
                >
                  <Shape kind={kind} color={color} size={30} />
                </span>
              </span>
            </div>
          )
        })}
        <div
          className='ap-talents__hint'
          style={anim({ at: [0.62, 0.7], y: 20 })}
        >
          <Shape kind='tri' color={C.yellow} size={26} />
          <span>
            <strong>{c.hintTitle}</strong>
            {c.hint}
          </span>
        </div>
      </div>

      <div
        className='ap-talents__score'
        style={anim({ at: [0.4, 0.5], s: 0.6, y: 0 })}
      >
        <span className='ap-talents__score-label'>{c.score}</span>
        <Odometer
          value={String(SCORE)}
          at={[0.42, 0.58]}
          className='ap-talents__score-num'
        />
        <span className='ap-talents__score-fit'>{c.fit}</span>
      </div>
    </div>
  )
}
